import { Row } from '@repo/ui/components'
import Image from 'next/image'
import React from 'react'
import type { LandingFooterLicensesConfig } from './landing-footer'

interface LandingFooterLicensesProps {
  className?: string
  config: LandingFooterLicensesConfig
}

export const LandingFooterLicenses = (props: LandingFooterLicensesProps) => {
  const { className = 'w-11 h-12', config } = props
  return (
    <Row className='gap-md flex-row-reverse justify-center'>
      {config?.enamad && (
        <a referrerPolicy='origin' target='_blank' href={config.enamad.url}>
          <img
            referrerPolicy='origin'
            src={config.enamad.imageUrl}
            alt=''
            className={`cursor-pointer ${className}`}
          />
        </a>
      )}
      {config?.mojavez && (
        <a referrerPolicy='origin' target='_blank' href={config.mojavez.url}>
          <Image
            src='/images/mojavez.ir.svg'
            alt='mojavez'
            className={`cursor-pointer`}
            width={48}
            height={48}
          />
        </a>
      )}
      {config?.nezam && (
        <a
          referrerPolicy='origin'
          target='_blank'
          href={config.nezam.url}
          rel='noreferrer'
        >
          <Image
            referrerPolicy='origin'
            src='/images/nezam-senfi.svg'
            alt='nezam-senfi'
            className={`cursor-pointer`}
            width={60}
            height={48}
          />
        </a>
      )}
    </Row>
  )
}
